var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandDiagonal = function SvgExpandDiagonal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "2.77 4.77 10.46 10.46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    fillRule: "evenodd",
    d: "M7.125 10.875a.44.44 0 0 0-.619 0l-2.859 2.86v-2.422a.438.438 0 0 0-.875 0v3.477c0 .242.196.438.437.438h3.478a.438.438 0 0 0 0-.875H4.266l2.859-2.86a.437.437 0 0 0 0-.618M8.875 9.125c.17.17.448.17.619 0l2.859-2.86v2.423a.438.438 0 0 0 .875 0V5.209a.437.437 0 0 0-.437-.437H9.313a.437.437 0 1 0 0 .875h2.421l-2.859 2.86a.437.437 0 0 0 0 .618",
    clipRule: "evenodd"
  })));
};
export default SvgExpandDiagonal;